import { Controller } from "@hotwired/stimulus"
import * as readonlyTagify from '../helpers/readonly_tagify.js'
import { prepareUnclosedMixTagOpeners, restoreUnclosedMixTagOpeners } from '../helpers/tagify_unclosed_mix_openers.js'

// Connects to data-controller="readonly-tagify"
export default class extends Controller {
  static values = {
    value: String,
    stepsMap: Object
  }

  connect() {
    // Create a temporary input element for tagify
    const tempInput = document.createElement('input')
    tempInput.type = 'text'
    const preparedValue = prepareUnclosedMixTagOpeners(this.valueValue || '')
    tempInput.value = preparedValue.value
    tempInput.style.display = 'none'

    // Add the temp input to the element
    this.element.appendChild(tempInput)

    // Initialize readonly tagify
    this.tagifyInstance = readonlyTagify.makeTagifyReadonly(tempInput)
    restoreUnclosedMixTagOpeners(this.tagifyInstance, preparedValue.token)

    // Show the tagify container and hide the temp input
    if (this.tagifyInstance) {
      const tagifyContainer = tempInput.parentElement.querySelector('.tagify')
      if (tagifyContainer) {
        tagifyContainer.style.display = 'block'
        tempInput.style.display = 'none'
      }
    }
  }

  disconnect() {
    if (this.tagifyInstance) {
      this.tagifyInstance.destroy()
    }
  }
}
